import { makeAppDisplayDetails, makeMarketplaceAppDisplayDetails, makeMarketplaceAppDisplayDetailsFromMarketplaceApp, makeSPIAppDisplayDetails, makeSPIAppDisplayDetailsFromSPIAddonDisplayDetails } from '@atlassian/mpac-spi';
import { makeScopeKey } from '@atlassian/mpac-types';
import { List, Record } from 'immutable';
export const makeInstallableApp = Record({
  details: makeSPIAppDisplayDetails(makeAppDisplayDetails()),
  marketplaceAppDetails: makeMarketplaceAppDisplayDetails(makeAppDisplayDetails()),
  scopes: List(),
  eligibleForFreeOnSandbox: false,
  cloudMigrationTrial: {
    isEligible: false
  }
});
export const makeInstallableAppFromSPIInstallableAddonAndMarketplaceAppData = (installableAddon, marketplaceApp, mpacBaseUrl) => makeInstallableApp({
  details: makeSPIAppDisplayDetailsFromSPIAddonDisplayDetails(installableAddon.details),
  marketplaceAppDetails: makeMarketplaceAppDisplayDetailsFromMarketplaceApp({
    marketplaceApp,
    mpacBaseUrl
  }),
  scopes: List(installableAddon.scopes).map(makeScopeKey),
  eligibleForFreeOnSandbox: installableAddon.eligibleForFreeOnSandbox,
  cloudMigrationTrial: installableAddon.cloudMigrationTrial
});